import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import withRedirect from 'components/common/hoc/withRedirect'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'
import { H2 } from 'components/common/Text/Text'
import { Title } from '../../components/Recovery/ForgotPages.styles'

const CreateAccountPage = ({
  registrationActions: [{
    displayName,
    link: { path }
  }],
  placeholders: {
    registrationContent
  },
  redirectTo,
  image
}) =>
  <Wrapper data-at-create-account-landing>
    <Col data-non-empty>
      { image && <Image alt="" src={ image } /> }
    </Col>
    <Col>
      <Heading data-at-heading headline narrow noMargin>CREATE AN ACCOUNT</Heading>
      <SubTitle data-at-sub-title bold block size={ 16 }>BENEFITS TO CREATING AN ACCOUNT</SubTitle>
      <div data-at-registration-content>
        { registrationContent }
      </div>
      <CreateAccountButton data-at-register-createanaccount narrow full="mobile" onClick={ () => redirectTo(path) }>
        { displayName }
      </CreateAccountButton>
    </Col>
  </Wrapper>

CreateAccountPage.propTypes = {
  image: PropTypes.string,
  placeholders: PropTypes.shape({
    registrationContent: PropTypes.node
  }),
  redirectTo: PropTypes.func,
  registrationActions: PropTypes.arrayOf(PropTypes.shape())
}

const CreateAccountPageWithRedirect = withRedirect(CreateAccountPage)

CreateAccountPageWithRedirect.type = 'RegisterUser'
CreateAccountPageWithRedirect.placeholders = ['registrationContent']

export default CreateAccountPageWithRedirect

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '15px 50px 128px 70px', '15px 16px 25px')}
`

const Col = styled.div`
  vertical-align: top;
  ${Media.desktop`
    display: table-cell;
    width: 50%;
  `}
  ${Mixin.responsive('margin-bottom', '0', '30px')};

  :first-of-type {
    ${Mixin.responsive('padding-right', '44px', '0')}
    ${Mixin.responsive('display', 'table-cell', 'none')}
  }
`

const SubTitle = styled(H2)`
  ${Mixin.responsive('margin', '25px 0 20px', '18px 0 10px')}
`

// TODO adjust styles
const Image = styled.img`
  max-width: 440px;
  max-height: 440px;
`

const CreateAccountButton = styled(Button)`
  ${Mixin.responsive('margin-top', '34px', '26px')}
`

const Heading = styled(Title)`
  margin-top: 0;
`
